import React from 'react';
import { I18n } from 'react-redux-i18n';
import { FaTimes } from 'react-icons/fa';
import './MigrationBanner.scss';

export const MIGRATION_BANNER_HEIGHT = 72;
export const MIGRATION_BANNER_HEIGHT_MOBILE = 88;

const DEFAULT_DEADLINE = 'August 31';
const CC_VERSION_COOKIE = 'cc_version=v3';

export const isMigrationBannerEnabled = () =>
  process.env.REACT_APP_MIGRATION_BANNER_ENABLED !== 'false';

export const getMigrationBannerDeadline = () =>
  process.env.REACT_APP_MIGRATION_BANNER_DEADLINE || DEFAULT_DEADLINE;

const handleTryNow = () => {
  document.cookie = CC_VERSION_COOKIE;
  window.location.href = `${window.location.origin}/?t=${Date.now()}`;
};

const MigrationBanner = ({ onDismiss, onTryNow }) => {
  if (!isMigrationBannerEnabled()) return null;

  const deadline = getMigrationBannerDeadline();
  const handleTryNowClick = onTryNow || handleTryNow;

  return (
    <div
      className="migration-banner"
      role="region"
      aria-label={I18n.t('MigrationBanner.title')}
    >
      <div className="migration-banner__content">
        <div className="migration-banner__text">
          <p className="migration-banner__title">
            {I18n.t('MigrationBanner.title')}
          </p>
          <p className="migration-banner__subtitle">
            {I18n.t('MigrationBanner.subtitle', { deadline })}
          </p>
        </div>
        <div className="migration-banner__actions">
          <button
            type="button"
            className="migration-banner__try-now"
            onClick={handleTryNowClick}
          >
            {I18n.t('MigrationBanner.tryNow')}
          </button>
          <button
            type="button"
            className="migration-banner__dismiss"
            onClick={onDismiss}
            aria-label={I18n.t('MigrationBanner.dismiss')}
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MigrationBanner;
